import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setSoundType } from "store/sounds";
import {
  clearNotificationsRequest,
  clearOneNotificationRequest,
  notificationsRequest,
} from "store/thunks";

export const useNotificationsRequest = () => {
  const dispatch = useDispatch();
  const token = Cookies.get("token");

  const fetchNotifications = async () => {
    if (token) {
      dispatch(notificationsRequest());
    }
  };

  const clearNotifications = () => {
    dispatch(setSoundType("main"));
    dispatch(clearNotificationsRequest());
  };

  const clearNotification = (id) => {
    dispatch(setSoundType("main"));
    dispatch(clearOneNotificationRequest(id)).then(() =>
      setTimeout(() => {
        fetchNotifications();
      }, 100)
    );
  };

  return { fetchNotifications, clearNotifications, clearNotification };
};
